import { ERC20 as ERC20Abi, H2Factory as H2FactoryAbi, H2Pair as H2PairAbi, H2Router as H2RouterAbi, } from './abis';
import { getContractAddress, getContractAddressMap } from './config';
import { AgentLauncher } from './modules/agentLauncher';
import { BondingCurveModule } from './modules/bondingCurve';
import { GasFeeEstimator } from './modules/gasFeeEstimator';
import { Swap } from './modules/swap';
import { getContract, getProvider } from './utils';
export class SDK {
    constructor(options) {
        this.getContract = (address, abi, signerOrProvider) => {
            if (!signerOrProvider) {
                signerOrProvider = getProvider(this.providerOptions);
            }
            return getContract(address, abi, signerOrProvider);
        };
        this.getContractAddress = (contractName) => {
            if (this.contractAddressMap) {
                return this.contractAddressMap[contractName];
            }
            return getContractAddress(this.providerOptions.chainId, contractName);
        };
        this.getERC20 = (address, signerOrProvider) => this.getContract(address, ERC20Abi, signerOrProvider);
        this.getH2Pair = (contractAddress, signerOrProvider) => this.getContract(contractAddress, H2PairAbi, signerOrProvider);
        this.getSwapModule = (signer) => {
            return new Swap({
                h2router: this.getContract(this.getContractAddress('H2Router'), H2RouterAbi, signer),
                h2factory: this.getContract(this.getContractAddress('H2Factory'), H2FactoryAbi, signer),
                addresses: this.getContractAddressMap(),
                signerOrProvider: signer ?? getProvider(this.providerOptions),
            });
        };
        this.getBondingCurveModule = (signer) => {
            return new BondingCurveModule({
                addresses: this.getContractAddressMap(),
                signerOrProvider: signer ?? getProvider(this.providerOptions),
            });
        };
        this.getAgentLauncher = (signer) => {
            return new AgentLauncher({
                addresses: this.getContractAddressMap(),
                signerOrProvider: signer ?? getProvider(this.providerOptions),
            });
        };
        const { providerOptions, contractAddressMap } = options;
        this.providerOptions = providerOptions;
        this.contractAddressMap = contractAddressMap;
    }
    getGasFeeEstimator() {
        return new GasFeeEstimator({
            provider: getProvider(this.providerOptions),
            addresses: this.getContractAddressMap(),
        });
    }
    toJSON() {
        return JSON.stringify({
            chainId: this.providerOptions.chainId,
        });
    }
    getContractAddressMap() {
        return (this.contractAddressMap ??
            getContractAddressMap(this.providerOptions.chainId));
    }
}
